import { useCallback, useState } from "react";

/**
 * クリップボードにコピーする
 */
export const useCopy = () => {
  const [history, setHistory] = useState<string[]>([]);

  // クリップボードにコピーする
  const copy = useCallback((value: string) => {
    navigator.clipboard.writeText(value).then(() => {
      setHistory((prev) => [...prev, value]);
      setTimeout(() => {
        setHistory((prev) => prev.filter((v) => v !== value));
      }, 2000);
    });
  }, [setHistory]);

  // 2秒以内にコピーしていたら true を返す
  const copiedRecently = useCallback((value: string) => {
    return history.includes(value);
  }, [history]);

  return {
    copy,
    copiedRecently,
  };
};
